import { ThemeProvider } from '@mui/material';
import React from 'react';
import { theme } from '..';

export const RenderWithMui: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => <ThemeProvider theme={theme}>{children}</ThemeProvider>;
